// Shared helpers for reading/writing a top-level "in cohort" / "not in cohort" segment
// condition inside a report's `source_request.filters` tree — the same shape ConditionField
// writes for the 'user.cohort' field (see ConditionsSchema.js / ConditionFields/ConditionField.vue).
// Used by the report view's segment quick-filter and the dashboard-level segment override
// (both ride the SegmentPicker.vue component).
//
// `filters` is either null, a bare condition triple [op, field, value], or a group
// [operator, ...conditions] where each condition is itself a triple or nested group.
// Only the top-level is inspected/managed here — a cohort condition nested inside a
// manually-built OR group is left alone and simply not reflected in the picker.

export function extractCohortConditionId(filters) {
  if (!Array.isArray(filters)) return null;
  const conditions = (filters[0] === 'and' || filters[0] === 'or') ? filters.slice(1) : [filters];
  const cohortCondition = conditions.find(c => Array.isArray(c) && c[1] === 'user.cohort' && (c[0] === 'in_cohort' || c[0] === 'not_in_cohort'));
  return cohortCondition ? cohortCondition[2] : null;
}

export function buildFiltersWithCohort(filters, cohortId) {
  let operator = 'and';
  let conditions = [];
  if (Array.isArray(filters)) {
    if (filters[0] === 'and' || filters[0] === 'or') {
      operator = filters[0];
      conditions = filters.slice(1);
    } else {
      conditions = [filters];
    }
  }
  conditions = conditions.filter(c => !(Array.isArray(c) && c[1] === 'user.cohort'));
  if (cohortId !== null && cohortId !== undefined) {
    conditions.push(['in_cohort', 'user.cohort', cohortId]);
  }
  return conditions.length ? [operator, ...conditions] : null;
}
